import { render, staticRenderFns } from "./financialAccountOpening.vue?vue&type=template&id=2f8474ce&scoped=true"
import script from "./financialAccountOpening.vue?vue&type=script&lang=js"
export * from "./financialAccountOpening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8474ce",
  null
  
)

export default component.exports